module.exports = __webpack_public_path__ + "static/img/mg-kf-index.e26dc20f.png";